import { FilterTransactionSummaryForm } from 'core/movimientos/components/FilterTransactionSummaryForm/FilterTransactionSummaryForm';
import { TransactionSummaryTableWithPagination } from 'core/movimientos/components/TransactionSummaryTableWithPagination/TransactionSummaryTableWithPagination';
import { TransactionSummaryContext } from 'core/movimientos/contexts/TransactionSummaryContext';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { PageTitle } from 'shared/components/Fonts';

export const TransactionSummaryPage = () => {
  const { searchParams, reloadToken } = useContext(TransactionSummaryContext);
  return (
    <Container fluid>
      <Row className="mb-3">
        <PageTitle>Totales Agrupados</PageTitle>
      </Row>
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Title>Filtros</Card.Title>
            <Card.Body>
              <FilterTransactionSummaryForm />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Title>Totales</Card.Title>
            <Card.Body>
              <TransactionSummaryTableWithPagination
                searchParams={searchParams}
                reloadToken={reloadToken}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
